export const UNLOCK_REVIEWS_ORIGIN = {
  REVIEWS_MODAL: "reviews-modal",
  WORKPLACE_PROFILE: "workplace-profile",
} as const;

export type UnlockReviewsOrigin =
  (typeof UNLOCK_REVIEWS_ORIGIN)[keyof typeof UNLOCK_REVIEWS_ORIGIN];

export interface UnlockReviewsLocationState {
  unlockReviewsOrigin?: UnlockReviewsOrigin;
}
